// extracted by mini-css-extract-plugin
export default {"brandPromo":"kG-z","carousel":"lG-z"};